// extracted by mini-css-extract-plugin
export default {"GamePage":"GamePage_GamePage__oVdN-","GamePage__h1":"GamePage_GamePage__h1__QLLNR","GamePage__table":"GamePage_GamePage__table__nuS85","GamePage__h2":"GamePage_GamePage__h2__y1NY5"};